const getWritingDirection = (lang) => {
  if (lang == "en") return "ltr";
  else if (lang == "ar") return "rtl";
};

export { getWritingDirection };
